import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      width: 'available',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: '5px',
      marginBottom: '5px',
      gap: '10px'
    },
    empty: {
      width: 'available',
      justifyContent: 'center',
      color: palette.danger.red,
      background: palette.background.underBox,
      borderRadius: palette.borderRadius.default
    },
    actionContainer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    buttonContainer: {
      display: 'flex',
      width: '100%',
      '& > button': {
        width: 'inherit'
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
